export const buildingList = [
    {
        color: '#f58862',
        buildingName: 'พระจอม'
    },
    {
        color: '#43a758',
        buildingName: 'วิทย์เก่า 1'
    },
    {
        color: '#a162f5',
        buildingName: 'วิทย์เก่า 2'
    },
    {
        color: '#cd6b6b',
        buildingName: 'โรงอาหารใหม่'
    },
    {
        color: '#f5f162',
        buildingName: 'จุฬาภรณ์ 1'
    },
    {
        color: '#62a2f5',
        buildingName: 'จุฬาภรณ์ 2'
    },
    {
        color: '#f56277',
        buildingName: 'หอประชุม'
    },
    {
        color: '#8fc6dd',
        buildingName: 'สโม'
    },
    {
        color: '#7a82b0',
        buildingName: 'ชุมนุม'
    },
    {
        color: '#cd6bcd',
        buildingName: 'โรงอาหารเก่า'
    },
    {
        color: '#4d8e8f',
        buildingName: 'Shop Physics'
    },
    {
        color: '#e1e19a',
        buildingName: 'สนามบาส'
    },
];